import { render, staticRenderFns } from "./Loginlayout.vue?vue&type=template&id=0f0fb878"
import script from "./Loginlayout.vue?vue&type=script&lang=js"
export * from "./Loginlayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports